import { IVariable } from "../../interfaces/IVariable";
import { createTheme, Theme } from "@mui/material/styles";
import { darkenColor } from "../../util/helpers";
import { getlocalStorageIdHotsite } from "../../util/LocalStorage";

let idHotsiteLocalStorage = getlocalStorageIdHotsite();

export const variables: IVariable = {
  IdHotsite: idHotsiteLocalStorage > 0 ?  idHotsiteLocalStorage : 1048,
  Loja: "EasyCambio",
  UserStorage: "61woB1tv+U6u38Ur0ST+9g==",
  UserToken: "X8POtru0qUiLizSiMFW4Kw==",
  UrlApi: "https://prd-ecommerce-duo-api.primecase.com.br/api",
  UrlLoja:"https://prd-ecommerce-eac-web.primecase.com.br/",
  UrlServiceHost: "https://dev2-pri-sgc-api.primecase.com.br/",
  OrgId: "",
  ProviderMerchantId: ""
};

export const template: Theme = createTheme({
  palette: {
    primary: {
      main: "#3949a0",
      light: "#3949a0",
      //lighter: "#ece6f7",
      dark: darkenColor("#3949a0", 10), // Escurece em 20%
    },
    secondary: {
      main: "#3949a0",
    },
    error: {
      main: "#a91c1c",
    },
    text: {
      primary: "#222",
      //light: "#fff",
    },
    warning: {
      main: "#ff9800",
    },
    // white: {
    //   main: "#fff",
    // },
  },

  typography: {
    subtitle1: {
      fontSize: 12,
    },
    body1: {
      fontSize: 14,
    },
  },
});
